import { render, staticRenderFns } from "./myService.vue?vue&type=template&id=85553ea4&scoped=true"
import script from "./myService.vue?vue&type=script&lang=js"
export * from "./myService.vue?vue&type=script&lang=js"
import style0 from "./myService.vue?vue&type=style&index=0&id=85553ea4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85553ea4",
  null
  
)

export default component.exports